<ng-container *transloco="let t">
  @let workingDays = this.workingDays();

  @if (workingDays && workingDays.isActive) {
    <div class="working-hours-dialog">
      @if (workingDays.customizeHoursByDay) {
        @for (dayOfWeek of workingDays.selectedDaysOfWeek; track dayOfWeek) {
          <p>
            <strong>{{ DAY_OF_WEEK_NAMES[dayOfWeek] }}: </strong>
            <span
              >{{
                getWorkingHoursMessage(
                  workingDays.daysOfWeekConfig[dayOfWeek].primaryWorkingHours,
                  workingDays.daysOfWeekConfig[dayOfWeek].secondaryWorkingHours
                )
              }}.</span
            >
          </p>
        }
      } @else {
        <p>
          <strong>{{ t('workingHours.daysText') }}: </strong>{{ daysOfWeekMessage() }}
        </p>
        @let workingHoursMessage =
          getWorkingHoursMessage(
            workingDays.primaryWorkingHours,
            workingDays.secondaryWorkingHours
          );

        @if (workingHoursMessage) {
          <p>
            <strong>{{ t('workingHours.workingHoursText') }}: </strong>
            <span>{{ workingHoursMessage }}.</span>
          </p>
        }
      }
    </div>
  }
</ng-container>
